import React from 'react';

import { Controller, useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useMutationExternalLogin } from 'api/mutations/externalLogin.mutation';
import { useMutationGetUserDomain } from 'api/mutations/getUserDomain.mutation';

import { ILoginForm } from 'components/App/AuthPublicPages/NewDesign/Login/Login';
import classes from 'components/App/AuthPublicPages/NewDesign/Login/Login.module.scss';
import { Layout } from 'components/App/AuthPublicPages/components/Layout/Layout';
import { TextInput } from 'components/DesignSystem/TextInput';
import { Button } from 'components/common';

export const ExternalRedirect = () => {
    const { handleSnackBar } = useCustomSnackBar();
    const { mutate: mutateGetUserDomain, isLoading: isLoadingGetUserDomain } = useMutationGetUserDomain();
    const { mutate: mutateExternalLogin, isLoading: isLoadingExternalLogin } = useMutationExternalLogin();
    const form = useForm<ILoginForm>();
    const handleLogin = (data: ILoginForm) => {
        mutateGetUserDomain(
            { username: data.username },
            {
                onSuccess: (response) => {
                    if (response.domain) {
                        mutateExternalLogin(
                            { username: data.username, password: data.password, domain: response.domain },
                            {
                                onSuccess: (responseLogin) => {
                                    window.location.href = `https://${response.domain}/externalLogin?email=${data.username}&token=${responseLogin.accessToken}`;
                                },
                                onError: (error) => {
                                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                                },
                            },
                        );
                    }
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    return (
        <Layout>
            <form className={classes.container} onSubmit={form.handleSubmit(handleLogin)}>
                <div className={classes.title}>Sign in to your account</div>
                <div className={classes.formRows}>
                    <div className={classes.row}>
                        <span className={classes.label}>Email</span>
                        <Controller
                            render={({ field }) => <TextInput {...field} clearable={false} />}
                            name={'username'}
                            control={form.control}
                        />
                    </div>
                    <div className={classes.row}>
                        <span className={classes.label}>Password</span>
                        <Controller
                            render={({ field }) => <TextInput {...field} type={'password'} clearable={false} />}
                            name={'password'}
                            control={form.control}
                        />
                    </div>
                    <div className={classes.row}>
                        <Button
                            variant={'primary'}
                            isLoading={isLoadingGetUserDomain || isLoadingExternalLogin}
                            type={'submit'}
                        >
                            Sign In
                        </Button>
                    </div>
                    <div className={classes.row}>
                        <Button component={Link} to={'/forgot-password'} variant={'tertiary'}>
                            Forgot Password?
                        </Button>
                    </div>
                </div>
            </form>
        </Layout>
    );
};
